const GroupWebUrl = "https://pathwayz.sportzvillage.com/groups/#/";
// const GroupWebUrl = "https://sportingbharat.com/groupschools_webpage/#/";

export default GroupWebUrl; 
